import { render, staticRenderFns } from "./ContentTypeCategoryForm.vue?vue&type=template&id=58e9fd55&scoped=true"
import script from "./ContentTypeCategoryForm.vue?vue&type=script&lang=js"
export * from "./ContentTypeCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./ContentTypeCategoryForm.vue?vue&type=style&index=0&id=58e9fd55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e9fd55",
  null
  
)

export default component.exports